export const PRICE_PER_PERSON = 260;

// Content & assets for the "Journée Bien-être du CE" landing page.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1760564019141-abe33455ce02?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920",
  leverSport: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  leverNutrition: "https://images.unsplash.com/photo-1543352634-a1c51d9f1fa7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  leverDetente: "/img/detente.jpg",
  formBg: "https://images.unsplash.com/photo-1760564019101-c265521c08f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const HOTELS = [
  {
    name: "La Toubana Hôtel & Spa",
    location: "Sainte-Anne, Guadeloupe",
    stars: "5★ Prestige",
    features: ["Perchée sur les falaises face à la mer", "Plage privée & piscine à débordement", "Spa panoramique et restaurant gastronomique"],
    image: "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cfe88_la-toubana-hotel-spa-hotel-guadeloupe-01.jpg",
  },
  {
    name: "Créole Beach Hôtel & Spa",
    location: "Le Gosier, Guadeloupe",
    stars: "4★",
    features: ["Vaste domaine tropical en bord de plage", "Deux piscines et jardins fleuris", "Spa & bar cocktails les pieds dans l'eau"],
    image: "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cf9a2_creole-beach.jpg",
  },
  {
    name: "Les Galets Rouges Lodges & Spa",
    location: "Bouillante, Guadeloupe",
    stars: "4★",
    features: ["Spa & sauna nichés face à la nature", "Terrasse, piscine & restauration en bord de mer", "Soins bien-être : massages, gommages & soins visage"],
    image: "/hotels/galets-1.jpg",
  },
  {
    name: "Le Grand Case Beach Club",
    location: "Grand Case, Saint-Martin",
    stars: "4★ Caraïbes",
    features: ["Accès direct à la plage face à Anguilla", "Cadre intimiste au cœur du village gourmand", "Terrasses vue mer & activités nautiques"],
    image: "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71d0031_grand-case-1.jpg",
  },
];

export const CSE_NEEDS = [
  {
    number: "01",
    title: "Expérience Haute Valorisation",
    desc: "Offrez une journée prestige 4 étoiles qui témoigne d'une reconnaissance sincère envers l'engagement quotidien de vos collaborateurs.",
    tag: "Reconnaissance & Marque Employeur",
  },
  {
    number: "02",
    title: "Cohésion & Esprit d'Équipe",
    desc: "Dépassez les réunions formelles grâce à des ateliers dynamiques collectifs dans un cadre bienveillant et stimulant.",
    tag: "Team Building Vivant",
  },
  {
    number: "03",
    title: "Bien-être & Prévention Active",
    desc: "Combinez dépistage bien-être, conseils nutritionnels concrets et relaxation profonde pour recharger durablement les énergies.",
    tag: "QVCT & Énergie",
  },
  {
    number: "04",
    title: "Cadre Premium 4 Étoiles",
    desc: "Piscine à débordement, activités nautiques, jardins tropicaux et salons de détente feutrés réservés pour votre groupe.",
    tag: "Luxe & Sérénité",
  },
  {
    number: "05",
    title: "Suivi Digital sur 21 Jours",
    desc: "L'expérience ne s'arrête pas au coucher du soleil : défi bien-être guidé avec une application, séances de sport et communauté inclus.",
    tag: "Impact Long Terme",
  },
];

export const LEVERS = [
  {
    index: "01",
    title: "Sport & BodyFitChallenge",
    subtitle: "Vitalité & Dépassement Collectif",
    accent: "#1A6B7C",
    image: "leverSport",
    details: [
      "Réveil musculaire au lever du soleil et défis sportifs en équipe",
      "Ateliers de mobilité posturale adaptés à tous les niveaux",
      "Lancement du challenge connecté 21 jours par équipes",
    ],
    highlight: "Coachs Bien-être 17 ans d'expérience",
  },
  {
    index: "02",
    title: "Nutrition & Analyse Corporelle",
    subtitle: "Science & Saveurs Locales",
    accent: "#C59B27",
    image: "leverNutrition",
    details: [
      "Bilan corporel individuel par bio-impédancemétrie",
      "Masterclass 'Nutrition Énergie & Terroir Antillais'",
      "Déjeuner gourmand sain 3 services signé par le Chef 4*",
    ],
    highlight: "Bilan individuel confidentiel",
  },
  {
    index: "03",
    title: "Détente & Soin / Cadeau",
    subtitle: "Relaxation & Rituel Privilège",
    accent: "#1E4A38",
    image: "leverDetente",
    details: [
      "Accès illimité aux espaces de détente (jacuzzi, deck, transats)",
      "Modelage décontractant ou soin visage aux extraits de plantes",
      "Coffret cadeau soin visage et corps remis à chaque collaborateur",
    ],
    highlight: "Coffret cadeau premium inclus",
  },
];

export const PICTOGRAMS = [
  { icon: "Sparkles", title: "Journée complète 4*", subtitle: "Privatisation partielle des espaces" },
  { icon: "Utensils", title: "Déjeuner gastronomique", subtitle: "Entrée, plat sain, dessert & jus détox" },
  { icon: "Activity", title: "Coaching & Bilan Bio", subtitle: "Séances physiques + scan corporel" },
  { icon: "HeartHandshake", title: "Soin ou Massage", subtitle: "Relaxation personnalisée & transat" },
  { icon: "Gift", title: "Coffret Bien-Être", subtitle: "Cadeau de marque offert à chacun" },
  { icon: "Smartphone", title: "App 21 Jours", subtitle: "Suivi digital & défis cohésion" },
];

export const PROGRAM_21 = [
  { day: "Jour 1", title: "L'Immersion 4*", desc: "Journée de déconnexion totale à l'hôtel, l'étincelle de vitalité et la dynamique de groupe." },
  { day: "Jours 2 à 10", title: "Le Challenge Micro-Habitudes", desc: "Défis hydratation, pauses actives au travail, fiches recettes antillaises via l'application dédiée." },
  { day: "Jours 11 à 21", title: "L'Ancrage & Célébration", desc: "Clôture du challenge inter-services, remise des badges de réussite et partage des victoires." },
];

export const METRICS = [
  { value: "260€", label: "par collaborateur, tout inclus" },
  { value: "4 Hôtels 4*", label: "cadres d'exception aux Antilles" },
  { value: "21 Jours", label: "d'accompagnement & challenge" },
  { value: "100% CSE", label: "éligible budget activités sociales" },
];

export const MARQUEE = [
  "Hôtels 4 Étoiles Guadeloupe & Îles",
  "BodyFitChallenge 21 Jours",
  "Nutrition externe & Soin du Visage",
  "Rituels Spa & Soins Signature",
  "Bilan Corporelle-Impédancemétrie",
  "Cohésion d'Équipe & Fierté Salarié",
];

export const TESTIMONIALS = [
  {
    quote: "Cette journée a créé une vraie dynamique collective. L'application a permis de poursuivre l'élan après l'événement.",
    author: "Responsable CSE",
    role: "Antilles",
  },
  {
    quote: "Le format plaît parce qu'il mélange détente, sport et conseils concrets. Les collaborateurs sont repartis avec le sourire.",
    author: "Élue CSE",
    role: "Services",
  },
  {
    quote: "Le cadre 4 étoiles a vraiment changé la perception de l'événement. Nos salariés se sont sentis privilégiés.",
    author: "Président de CSE",
    role: "",
  },
];

export const FAQ_ITEMS = [
  {
    q: "À qui s'adresse cette journée ?",
    a: "Aux CSE souhaitant une action collective, valorisante et accessible.",
  },
  {
    q: "Combien de participants ?",
    a: "À partir de 15 personnes, avec des tarifs dégressifs.",
  },
  {
    q: "Où se déroule l'événement ?",
    a: "Dans nos hôtels partenaires en Guadeloupe ou Saint-Martin.",
  },
  {
    q: "Et après la journée ?",
    a: "La dynamique continue pendant 21 jours via l'application BodyFitChallenge 21.",
  },
];

export const REASSURANCE = "Format accessible à tous les niveaux, exercices ajustables et analyses corporelles confidentielles.";

export const NAV_LINKS = [
  { name: "Pourquoi le CSE ?", href: "#besoins-cse" },
  { name: "Les 3 Leviers", href: "#les-3-leviers" },
  { name: "Hôtels & Tarifs", href: "#hotels-tarifs" },
  { name: "Programme 21j", href: "#programme-21j" },
  { name: "FAQ", href: "#faq" },
];

export const LOGOS = [
  "CSE Air Caraïbes",
  "Orange Antilles",
  "Amicale Territoriale",
  "CSE Banque des Îles",
  "Groupe Karukera",
  "CE Sara Énergies",
];

export const SATISFACTION = { score: "4,9", max: "5", count: "40+ CSE accompagnés" };

export const EFFECTIF_OPTIONS = ["10 à 25 personnes", "26 à 50 personnes", "51 à 100 personnes", "Plus de 100 personnes"];
export const ILE_OPTIONS = ["Guadeloupe (Grande-Terre / Basse-Terre)", "Saint-Martin", "Indifférent / Conseil recommandé"];
export const PERIODE_OPTIONS = ["Prochain mois", "Dans 2 à 3 mois", "Ce semestre", "Fin d'année / Début d'année"];

// Galleries indexed to match HOTELS order.
export const HOTEL_GALLERIES = [
  [
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cfe88_la-toubana-hotel-spa-hotel-guadeloupe-01.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffea_toubana-9.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffed_toubana-12.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffe9_toubana-8.jpg",
  ],
  [
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cf9a2_creole-beach.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffc4_creole-3.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffc5_creole-4.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71cffc6_creole-5.jpg",
  ],
  [
    "/hotels/galets-1.jpg",
    "/hotels/galets-2.jpg",
    "/hotels/galets-3.jpg",
    "/hotels/galets-4.jpg",
  ],
  [
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71d0031_grand-case-1.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71d002d_grand-case-2.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71d0030_grand-case-3.jpg",
    "https://cdn.prod.website-files.com/67c809b5f63deab8a71cf757/67c809b5f63deab8a71d002f_grand-case-4.jpg",
  ],
];
